module.exports = __webpack_public_path__ + "static/media/icon_guidePage.6471ba61.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_guidePage.png
// module id = 773
// module chunks = 0 1